module.exports = __webpack_public_path__ + "static/media/logodark.bfa7fb55.svg";